<div class="daily-page">
  <h1>Daily KPI Form</h1>

  @if (loading()) {
    <stena-skeleton-loader type="text" [rows]="3" />
  } @else {
    <app-context-picker
      class="pickers"
      [costCenters]="costCenters()"
      [months]="monthOptions()"
      [initialCostCenterId]="selectedCostCenterId()"
      [initialMonthId]="selectedMonthId()"
      (costCenterIdChange)="selectedCostCenterId.set($event)"
      (monthIdChange)="selectedMonthId.set($event)"
    />

    @if (form(); as f) {
      <section class="working-days" [formGroup]="workingDaysForm">
        <stena-input
          class="dense-3"
          label="Working days"
          type="number"
          formControlName="workingDays"
        />
        <stena-button
          type="stroked"
          text="Save working days"
          [disabled]="
            saving() || workingDaysForm.controls.workingDays.value === null
          "
          (buttonClick)="onSaveWorkingDays()"
        />
      </section>

      @if (f.columns.length === 0) {
        <p class="hint">No daily KPIs are configured for this cost center.</p>
      } @else {
        <section class="grid-scroll">
          <table class="daily-grid">
            <thead>
              <tr>
                <th class="day-col">Day</th>
                @for (col of f.columns; track col.kpiBaseId) {
                  <th>
                    {{ col.name }}
                    @if (col.unit) {
                      <span class="unit">({{ col.unit }})</span>
                    }
                  </th>
                }
              </tr>
            </thead>
            <tbody>
              @for (day of days(); track day) {
                <tr>
                  <td class="day-col">{{ day }}</td>
                  @for (col of f.columns; track col.kpiBaseId) {
                    <td>
                      <input
                        type="number"
                        step="0.001"
                        [ngModel]="getValue(day, col.kpiBaseId)"
                        (ngModelChange)="setValue(day, col.kpiBaseId, $event)"
                      />
                    </td>
                  }
                </tr>
              }
            </tbody>
            <tfoot>
              <tr>
                <td class="day-col total-label">Total</td>
                @for (col of f.columns; track col.kpiBaseId) {
                  <td class="total-cell">
                    {{ columnTotals().get(col.kpiBaseId) }}
                  </td>
                }
              </tr>
            </tfoot>
          </table>
        </section>

        <stena-button
          type="raised"
          color="primary"
          text="Save all cells"
          [disabled]="saving()"
          (buttonClick)="onSave()"
        />
      }
    } @else {
      <p class="hint">Select cost center and month to load the daily grid.</p>
    }
  }
</div>
